module.exports = __webpack_public_path__ + "img/left.9ab9054f.png";